export { Group, Text, Image, Arc, Area, Circle, Line, Path, Rect, RichText } from '@visactor/vtable/es/vrender';
